import React, { PropsWithChildren } from 'react';

const CropsList: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className='scrollbar-track-gray-200 flex max-h-full w-full flex-col gap-y-2 overflow-y-auto scrollbar-thin scrollbar-thumb-background-200'>
      {children}
    </div>
  );
};

export default CropsList;
